import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { staticStyles } from './style';

const TreeNode = ({ node, depth, selectedNodeName, onSelectNode }) => {
  const [expanded, setExpanded] = useState(false);
  const hasChildren = node.tree_data && node.tree_data.length > 0;
  const isActive = selectedNodeName === node.name;

  const handleClick = () => {
    onSelectNode(node);
    if (hasChildren) {
      setExpanded(prev => !prev);
    }
  };

  return (
    <div className={`tree-node ${depth === 0 ? 'tree-node-root' : ''}`}>
      {hasChildren && depth > 0 && <div className="tree-line" />}
      <div
        className={`tree-node-content ${isActive ? 'active' : ''}`}
        onClick={handleClick}
        role="button"
        tabIndex={0}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') handleClick();
        }}>
        <span className={`tree-toggle ${hasChildren ? (expanded ? 'expanded' : '') : 'hidden'}`}>▶</span>
        <span className={`tree-node-name ${depth === 0 ? 'tree-node-root-name' : ''}`} title={node.name}>
          {node.name || 'Unknown'}
        </span>
      </div>
      {hasChildren && (
        <div className={`tree-children ${expanded ? 'expanded' : 'collapsed'}`}>
          {node.tree_data.map((child, index) => (
            <TreeNode
              key={`${child.name}-${index}`}
              node={child}
              depth={depth + 1}
              selectedNodeName={selectedNodeName}
              onSelectNode={onSelectNode}
            />
          ))}
        </div>
      )}
    </div>
  );
};

TreeNode.propTypes = {
  node: PropTypes.shape({
    name: PropTypes.string,
    reward_data: PropTypes.object,
    tree_data: PropTypes.array,
  }).isRequired,
  depth: PropTypes.number.isRequired,
  selectedNodeName: PropTypes.string,
  onSelectNode: PropTypes.func.isRequired,
};

TreeNode.defaultProps = {
  selectedNodeName: '',
};

const SubIBProgramsTree = ({ treeData, onSelectNode, selectedNodeName }) => {
  if (!treeData) return null;

  return (
    <div className="SubIBProgramsTree">
      <TreeNode node={treeData} depth={0} selectedNodeName={selectedNodeName} onSelectNode={onSelectNode} />
      <style jsx global>
        {staticStyles}
      </style>
    </div>
  );
};

SubIBProgramsTree.propTypes = {
  treeData: PropTypes.object,
  onSelectNode: PropTypes.func.isRequired,
  selectedNodeName: PropTypes.string,
};

SubIBProgramsTree.defaultProps = {
  treeData: null,
  selectedNodeName: '',
};

export default SubIBProgramsTree;
